import { CompanyDetail } from "@/features/company/pages/CompanyDetail";
import { FC } from "react";

const CompanyDetailPage: FC = () => {
  return <CompanyDetail />;
};

export default CompanyDetailPage;
